import { render, staticRenderFns } from "./DialogPublishers.vue?vue&type=template&id=281ccd28&"
import script from "./DialogPublishers.vue?vue&type=script&lang=js&"
export * from "./DialogPublishers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports